import React from 'react';
import {
  Grid2,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  CircularProgress,
  Box,
} from '@mui/material';
import useAlias from '@hooks/useAlias';
import { FilterField } from '../types';
import { StyledFilterControl } from '../DataPointSearch.styles';

interface FilterDropdownProps {
  field: FilterField;
  label: string;
  value: string;
  options: string[];
  loading: boolean;
  disabled: boolean;
  onChange: (value: string) => void;
  formatOption?: (option: string) => string;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  field,
  label,
  value,
  options,
  loading,
  disabled,
  onChange,
  formatOption = (o) => o,
}) => {
  const alias = useAlias();

  const handleChange = (e: SelectChangeEvent) => {
    onChange(e.target.value);
  };

  return (
    <Grid2 size={{ xs: 12, sm: 6, md: 2 }}>
      <StyledFilterControl
        fullWidth
        size='small'
        disabled={disabled || loading}
        isDisabled={disabled}
      >
        <InputLabel id={`${field}-label`}>{alias(label)}</InputLabel>
        <Select
          labelId={`${field}-label`}
          value={value}
          label={alias(label)}
          onChange={handleChange}
          renderValue={(selected) =>
            selected ? formatOption(selected as string) : ''
          }
          endAdornment={
            loading ? (
              <Box sx={{ display: 'flex', mr: 3 }}>
                <CircularProgress size={16} />
              </Box>
            ) : null
          }
        >
          <MenuItem value=''>
            <em>
              {alias('All')} {alias(label)}
            </em>
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              {formatOption(option)}
            </MenuItem>
          ))}
        </Select>
      </StyledFilterControl>
    </Grid2>
  );
};

FilterDropdown.displayName = 'FilterDropdown';

export default FilterDropdown;
